export const MAX_TOP_HOLDERS = 5_000;
export const MAX_DISPLAYED_TOP_HOLDERS = 100;
